module.exports = __webpack_public_path__ + "img/CV.c823e988.svg";